export default __webpack_public_path__ + "static/footer-bg-4a178d6272ddb4a488cb2c02a04c95e4.webp";